
export { ErrorBoundary } from "/builds/benzinga/fusion/libs/ui/core/src/components/ErrorBoundary/index.tsx"